import type { CmlContent } from 'bundles/cml';

import type { ForumPostWithCreator } from '../components/forumsV2-ForumThreads/__providers__/ForumPostDataProvider/__types__';

const CONTEXT_KEY = 'discussionsV2Context-';

export type ContextData = {
  question?: ForumPostWithCreator;
  answerSavingStates?: Record<string, string>;
  isUpvoted?: boolean;
  courseId?: string;
  userId?: string;
  retryCml?: Record<string, { content: CmlContent }>;
};
const memorySpace: Record<string, ContextData> = {};

function storageKey(forumPostId: string) {
  return `${CONTEXT_KEY}${forumPostId}`;
}
/**
 * @description: this function is a bugfix to avoid a redesign of how the forums in memory 'active forum' context is working
 * the long term goal here is to move this logic either back to a fluxible store, or to make it into a data provider
 * pattern with modern react context.
 */

const discussionsV2ContextSessionStorage = {
  set: (forumPostId: string, data: any) => {
    const oldData = discussionsV2ContextSessionStorage.get(forumPostId);
    const newData = oldData || {};
    const key = storageKey(forumPostId);
    // partial update happening for the use case of Like / Reply optimistic updates.
    memorySpace[key] = { ...newData, ...data };
  },
  get: (forumPostId: string): ContextData | undefined => {
    const key = storageKey(forumPostId);
    if (memorySpace[key]) {
      return memorySpace[key];
    }
    return {};
  },
};

export default discussionsV2ContextSessionStorage;
